import React from 'react';
import CloseIcon from 'assets/close.svg';
import { FullProduct } from 'screens/Applications&WorkOrders/Applications/Hooks/useApplication';

interface HeaderProps {
  product: FullProduct;
  onClose: () => void;
}

const Header = ({ product, onClose }: HeaderProps) => {
  return (
    <div className="relative">
      <button
        type="button"
        aria-label="Close"
        onClick={onClose}
        className="absolute right-0"
      >
        <img alt="close" src={CloseIcon} width={18} height={18} />
      </button>
      <div>
        <h2 className="text-xl font-semibold">{product.productName}</h2>
        <p className="text-neutral-60 text-sm mt-1">
          {product.manufacturerName}
        </p>
      </div>
    </div>
  );
};

export default Header;
